import { getColor, getSize } from "views/resources/theme";
import styled from "styled-components";

const Content = styled.div`
	background-color: ${getColor("bg_alt")};
	/* padding-bottom: 7rem; */
	margin-top: 30px;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;

	padding-bottom: ${(props) => (props.reservationScreen ? 0 : "56px")};
	.card {
		background-color: ${getColor("bg")};
		margin: ${getSize("m")};
		margin-top: 0;
	}
`;

export default Content;
